import Fractal from './Fractal.vue';

export default Fractal;
